import axios from "axios";
// Import de Context
import { useDataContext } from "../Context/dataContext";
import { clearLocalStorage } from "../Hooks/useLocalStorage";
import { NavLink, useHistory } from "react-router-dom";
import {
  FaHome,
  FaListAlt,
  FaUserFriends,
  FaUserCircle,
  FaSignOutAlt,
} from "react-icons/fa";

function UserNavbar({ logOut }) {
  const history = useHistory();
  const { url } = useDataContext();

  const handleLogout = () => {
    axios
    .get(`${url}/Auth/logout/${logOut}`)
    .then((response) => {
      console.log("Logout successful:", response.data);
    })
    .catch((error) => {
      console.error("There was an error logging out:", error);
    });
    clearLocalStorage();
    history.push("/Login");
  };

  return (
    <nav className="user-navbar">
      <NavLink exact to="/Changes" activeClassName="active">
        <FaHome />
        <span>Principal</span>
      </NavLink>

      <NavLink to="/Directory" activeClassName="active">
        <FaListAlt />
        <span>Directorio</span>
      </NavLink>

      <NavLink to="/Referidos" activeClassName="active">
        <FaUserFriends />
        <span>Referidos</span>
      </NavLink>

      <NavLink to="/Profile" activeClassName="active">
        <FaUserCircle />
        <span>Perfil</span>
      </NavLink>

      <button onClick={handleLogout}>
        <FaSignOutAlt />
        <span>Salir</span>
      </button>
    </nav>
  );
}

export { UserNavbar };
